module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUBAMAAACZjst6AAAAG1BMVEXe4+bw8/Pz9fX19/f3+fn5+/v8/P39/v7///9kr4t5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gEODiQjYE40ogAAAEtJREFUCNdjUIICBQZjKDBgcIECB4ZQKAhgSIOCBCRWeUF5OXt5eXkBQwcDRwNDR0cHkGhgYOCAsDoYQEKoLIQsko6ODpgOCCCDBQALNkfah4uKEgAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/clear_20.png
 ** module id = 195
 ** module chunks = 0 1
 **/